import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Processing' },
    { value: 2, label: 'Ready' },
    { value: 3, label: 'Failed' },
    { value: 4, label: 'Cancelled' },
  ],
});
